import { ark } from '@ark-ui/react/factory'

import { cn } from '~/utils/cn'
import type { VariantProps } from '~/utils/tv'

import { labelStyles } from './label.styles'

export type LabelProps = React.ComponentProps<typeof ark.span> &
  VariantProps<typeof labelStyles>

export function Label({ className, size, ...props }: LabelProps) {
  return (
    <ark.span
      {...props}
      className={cn(
        labelStyles({
          className,
          size,
        })
      )}
    />
  )
}
